// Angular
import { IToteResultResponse } from '@amwager/util-ts';
import { WagerFacade } from '@amwager/wager/data-access';
import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  ViewChild,
  // OnDestroy,
  OnInit,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  SafeUrl,
  DomSanitizer
} from '@angular/platform-browser';

// Local library
import {
  DateFormatPipe,
  SanitizerPipe
} from '@amwager/util';

// Ionic
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonTitle,
  IonToolbar,
  ModalController
} from '@ionic/angular/standalone';

//Third party
import videojs from 'video.js';
import Hls from 'hls.js';
import { Subscription } from 'rxjs';

@Component({
  selector: 'feature-ion-play-video',
  templateUrl: './play-video.component.html',
  styleUrls: ['./play-video.component.scss'],
  imports: [
    CommonModule,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonContent,
    IonItem,
    IonInput,
    FormsModule,
    SanitizerPipe,
    DateFormatPipe
  ],
  standalone: true
})

export class PlayVideoComponent implements OnInit, OnDestroy, AfterViewInit {

  private getSelectedReplayInfoSubs!: Subscription;
  isReplayInfoSuccess: boolean = false;
  name: string | undefined;
  videoUrl?: string;
  private video!: any;
  private hls!: any;
  safeUrl!: SafeUrl;

  track: string = '';
  date: string = '';
  breed: string = '';
  race: string = '';

  @ViewChild('videoPlayer', {static: true}) videoPlayer!: ElementRef<HTMLVideoElement>;

  constructor(
    private modalCtrl: ModalController,
    private wagerFacade: WagerFacade,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.wagerFacade.getSelectedReplayInfo$().subscribe((res?: any) => {
      if (res !== undefined) {
        this.track = res.track;
        this.date = res.date;
        this.breed = res.breed;
        this.race = res.race;

        this.isReplayInfoSuccess = true;
      }

      if (this.getSelectedReplayInfoSubs && this.isReplayInfoSuccess)
        this.getSelectedReplayInfoSubs.unsubscribe();
    });
  }

  ngAfterViewInit() {
    const videoElement = this.videoPlayer.nativeElement;

    let i = 0;
    this.wagerFacade.getRaceResult$()
    .subscribe((results?: IToteResultResponse) => {
      this.videoUrl = undefined;

      if (!results || !results?.replayVideo || i > 0) return;

      const replayVideo = results?.replayVideo.replace(/^http:/, 'https:');

      this.cleanupVideoPlayer();

      this.video = videojs(videoElement || '', {
      }, function onPlayerReady() {
        console.log('onPlayerReady');
      });

      if (Hls.isSupported()) {
        // const hls = new Hls();
        this.hls = new Hls();
        this.hls.loadSource(replayVideo);
        this.hls.attachMedia(videoElement);
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          videoElement.play();
        });
      }

      i++;
    });
  }

  ngOnDestroy() {
    this.cleanupVideoPlayer();
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  close() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  private cleanupVideoPlayer() {
    // if (this.hls) {
    //   this.hls.destroy();
    // }

    if (this.video) {
      this.video.pause();
      this.video.dispose();
    }
  }

}
